import { useEffect } from 'react';
import { Common, color } from '@stockbit/ui';

// Components
import Divider from 'global/AuthCardLayout/Divider';
import AuthCardLayout from 'global/AuthCardLayout';
import GoogleOauth from '../GoogleOauth';
import FacebookOauth from '../FacebookOauth';

const { Button, Text } = Common;

interface SelectionProps {
  handleOnMount: () => void;
  handleNavigate: () => void;
}

function Selection({
  handleOnMount,
  handleNavigate,
}: SelectionProps): JSX.Element {
  useEffect(() => {
    if (handleOnMount) handleOnMount();
  }, []);

  return (
    <AuthCardLayout withLoginLink withTermsLink wrapperClassName="register">
      <GoogleOauth />
      <FacebookOauth />
      <Divider label="Or" className="form-divider" />
      <Button
        id="email-register"
        type="primary"
        onClick={handleNavigate}
        height="44px"
        block
      >
        <Text color={color.light} size="14px" family="bold">
          Register with Email
        </Text>
      </Button>
    </AuthCardLayout>
  );
}

export default Selection;
